export interface WindowEnvironmentProps {
  ENV: Application.PublicEnvironmentVariables;
}

export function WindowEnvironment({ENV = {}}: WindowEnvironmentProps) {
  return <script dangerouslySetInnerHTML={{__html: `window.ENV = ${JSON.stringify(ENV)}`}} />;
}
